import { z } from 'zod'
import {
  BasePhotoObject,
  PhotoPetDataSchema,
} from 'components/PhotoBank/PhotoBank.schemas'
import { createAiWallOfferSchema } from '../aiWall/aiWall.schemas'
import { createCartUpsellRecordSchema } from '../cartUpsellRecord.schemas'
import { PET_SPECIES } from './petCandidate'

const PetAiWallGenerationFields = {
  // The candidate's main pet, kept on the record because an older bundle rewrites the photo bank without `petDetection`.
  sourcePetBox: PhotoPetDataSchema.pick({
    x: true,
    y: true,
    width: true,
    height: true,
  }),
  sourcePetSpecies: z.enum(PET_SPECIES),
  sourceUploadSrc: BasePhotoObject.shape.uploadSrc,
}

type PetAiWallVariants = { variantIndexes: number[] }

export function createPetAiWallOfferSchema({
  variantIndexes,
}: PetAiWallVariants) {
  return createAiWallOfferSchema(variantIndexes.length).extend(
    PetAiWallGenerationFields
  )
}
export type PetAiWallOffer = z.infer<
  ReturnType<typeof createPetAiWallOfferSchema>
>

export function createPetAiWallRecordSchema(upsell: PetAiWallVariants) {
  return createCartUpsellRecordSchema(
    createPetAiWallOfferSchema(upsell),
    PetAiWallGenerationFields
  )
}
